/**
 * @generated SignedSource<<ae575abec3161777acd385178274168f>>
 * @relayHash 73d83e15c0dcd8f51610be1a44d77614
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e09890fd62940c18450f16c7b800d12192b6cf88b71dd44d4e5c2c55ff459796

import type { ConcreteRequest } from 'relay-runtime';
export type useSpacesDataStarredSpacesQuery$variables = {
  includeUserGeneratedSpaces?: boolean | null;
};
export type useSpacesDataStarredSpacesQuery$data = {
  readonly spaces: {
    readonly __typename: "PaginatedSpaceList";
    readonly nodes: ReadonlyArray<{
      readonly alias: string | null;
      readonly icon: {
        readonly path: string;
      } | null;
      readonly id: string | null;
      readonly key: string | null;
      readonly name: string | null;
      readonly status: string | null;
    } | null> | null;
  } | null;
  readonly userGeneratedSpaces?: {
    readonly count: number | null;
  } | null;
};
export type useSpacesDataStarredSpacesQuery = {
  response: useSpacesDataStarredSpacesQuery$data;
  variables: useSpacesDataStarredSpacesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "includeUserGeneratedSpaces"
  }
],
v1 = {
  "kind": "Literal",
  "name": "status",
  "value": "current"
},
v2 = [
  {
    "args": [
      {
        "kind": "Literal",
        "name": "favourite",
        "value": true
      },
      {
        "kind": "Literal",
        "name": "first",
        "value": 30
      },
      (v1/*: any*/)
    ],
    "concreteType": "PaginatedSpaceList",
    "kind": "LinkedField",
    "name": "spaces",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "__typename"
      },
      {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "alias"
          },
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "kind": "ScalarField",
            "name": "name"
          },
          {
            "kind": "ScalarField",
            "name": "key"
          },
          {
            "kind": "ScalarField",
            "name": "status"
          },
          {
            "concreteType": "Icon",
            "kind": "LinkedField",
            "name": "icon",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "path"
              }
            ]
          }
        ]
      }
    ],
    "storageKey": "spaces(favourite:true,first:30,status:\"current\")"
  },
  {
    "condition": "includeUserGeneratedSpaces",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "alias": "userGeneratedSpaces",
        "args": [
          {
            "kind": "Literal",
            "name": "excludeTypes",
            "value": "system,personal"
          },
          {
            "kind": "Literal",
            "name": "first",
            "value": 1
          },
          (v1/*: any*/)
        ],
        "concreteType": "PaginatedSpaceList",
        "kind": "LinkedField",
        "name": "spaces",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "count"
          }
        ],
        "storageKey": "spaces(excludeTypes:\"system,personal\",first:1,status:\"current\")"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useSpacesDataStarredSpacesQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSpacesDataStarredSpacesQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "73d83e15c0dcd8f51610be1a44d77614",
    "id": "e09890fd62940c18450f16c7b800d12192b6cf88b71dd44d4e5c2c55ff459796",
    "metadata": {},
    "name": "useSpacesDataStarredSpacesQuery",
    "operationKind": "query",
    "text": "query useSpacesDataStarredSpacesQuery($includeUserGeneratedSpaces:Boolean=false){spaces(favourite:true,first:30,status:\"current\"){__typename,nodes{alias,id,name,key,status,icon{path}}},userGeneratedSpaces:spaces(first:1,status:\"current\",excludeTypes:\"system,personal\")@include(if:$includeUserGeneratedSpaces){count}}"
  }
};
})();

(node as any).hash = "a96bdb54596b720a5f4c2c48c7e6dd59";

export default node;
